module.exports = __webpack_public_path__ + "img/honor-right-2-2.9b537c6e.jpg";